import { useEffect } from 'react';

interface SchemaJSONLDProps {
  data: Record<string, any>;
}

export const SchemaJSONLD = ({ data }: SchemaJSONLDProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.setAttribute('data-schema', 'true');
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [data]);

  return null;
};
